import moment from 'moment'
export let momentJS = () => {
    moment.locale('pt-BR');

    let getYear = () => {
        let date = moment().format("YYYY")
        return date
    }
    let formatDateTime = (date) => {
        date = moment(date).format("YYYY-MM-DD HH:mm")
        return date
    }

    let addDay = (date, day) => {
        date = moment(date).add(day, 'day')
        return date._d
    }

    let getDateTime = () => {
        let date = moment().format("YYYY-MM-DD HH:mm")
        return date
    }

    let formatDateForPTBR = (date) => {
        date = moment(date).format("DD/MM/YYYY")
        return date
    }

    let formatDateTimeForPTBR = (date) => {
        date = moment(date).format("DD/MM/YYYY HH:mm")
        return date
    }

    let getDateTimeLocal = () => {
        let date = moment().format("YYYY-MM-DDThh:mm");
        return date
    }

    let formatPTBRForMYSQL = (data) => {
        data = moment(data).format("YYYY-MM-DD")
        return data
    }

    let formatYear = (data) => {
        data = moment(data).format("YYYY")
        return data
    }

    let getDatePTBR = () => {
        let date = moment().format("DD-MM-YYYY");
        return date
    }

    let getFirstAndLastDayOfMonth = () => {
        // Primeiro dia de dois meses atrás 
        let firstDay = moment().subtract(1, 'months').startOf('month').format("YYYY/MM/DD");

        // Último dia do mês anterior 
        let lastDay = moment().endOf('month').format("YYYY/MM/DD");
        return { firstDay, lastDay };
    }

    return {
        getYear, formatDateTime, getDateTime, formatDateTimeForPTBR, formatDateForPTBR, getDateTimeLocal, addDay,
        formatPTBRForMYSQL, formatYear, getDatePTBR, getFirstAndLastDayOfMonth
    }
}

export let numberJS = () => {
    const numeral = require('numeral');
    require('numeral/locales');
    numeral.locale('pt-br');

    let getNumber = (number) => {

        return numeral(number).value();
    }

    let formatBRL = (number) => {
        number = numeral(number)
        return number.format('$0,0.00')

    }

    let totalOrder = (products) => {
        let total = 0;
        let productsList = [];
        for (let product of products) {
            let newPrice = numberJS().getNumber(product.price);
            let newAmount = numberJS().getNumber(product.amount);
            total = +(newPrice * newAmount);
            productsList.push(total);
        }

        total = 0;
        for (let product of productsList) {
            total += product;
        }

        return numberJS().formatBRL(total);
    }

    let formatPercent = (number) => {
        number = numeral(number)
        return number.format('0,0')
    }

    return { getNumber, formatBRL, totalOrder, formatPercent }


}

export let fileTools = () => {

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    return { toBase64 }
}



export default { momentJS, numberJS, fileTools }